import { CONSTANTS } from '../config/constants';
import MapObject from '../models/map_object';

document.addEventListener('DOMContentLoaded', () => {
	// Map object mapping
	if (document.getElementById('map-object') && typeof W.map_object !== 'undefined') {
		let map = new mapboxgl.Map({
			container: 'map-object',
			style: CONSTANTS.map_style,
			center: CONSTANTS.map_center,
			zoom: 16,
			minZoom: 13,
			maxZoom: 20,
			maxBounds: [
				[-89.6, 42.96],
				[-89.3, 43.2],
			],
			scrollZoom: true,
			pitchWithRotate: false,
			dragRotate: false,
			hash: false,
			trackResize: true,
		});

		map.on('load', () => {
			var map_object = new MapObject(W.map_object.id);
			map_object.fetch().then((model) => {
				if (model.data.geojson) {
					map.addSource('map-object-source', {
						type: 'geojson',
						data: model.data.geojson,
					});

					map.addLayer({
						id: 'map-object-points-layer',
						type: 'symbol',
						source: 'map-object-source',
						layout: {
							'icon-image': 'location-dot-00759b',
							'icon-offset': [0, 0],
							'icon-anchor': 'bottom',
							'icon-size': 1.5,
							'icon-allow-overlap': true,
							'icon-ignore-placement': true,
						},
						filter: ['==', '$type', 'Point'],
					});

					map.addLayer(
						{
							id: 'map-object-polygons-layer',
							type: 'fill',
							source: 'map-object-source',
							paint: {
								'fill-color': '#c5050c',
							},
							filter: ['==', '$type', 'Polygon'],
						},
						'uw-labels',
					);

					const type = model.data.geojson.type;
					// if MultiPolygon, calculate the minmax lng and lat
					// so we can fitBounds to show entire MultiPolygon
					if (type === 'MultiPolygon') {
						let minMax = {};
						model.data.geojson.coordinates.forEach((polygon) => {
							polygon[0].forEach((lnglat) => {
								minMax.xMin = minMax.xMin < lnglat[1] ? minMax.xMin : lnglat[1];
								minMax.xMax = minMax.xMax > lnglat[1] ? minMax.xMax : lnglat[1];
								minMax.yMin = minMax.yMin < lnglat[0] ? minMax.yMin : lnglat[0];
								minMax.yMax = minMax.yMax > lnglat[0] ? minMax.yMax : lnglat[0];
							});
						});
						map.fitBounds(
							[
								[minMax.yMin, minMax.xMin],
								[minMax.yMax, minMax.xMax],
							],
							{ padding: 20, maxZoom: 16 },
						);
					} else {
						// if not MultiPolygon, pan to feature's lnglat
						// This will not handle GeometryCollection, with a mix
						// of polygons and points. Oh well; very edge case.
						map.panTo(model.data.lnglat);
					}
				}
			});
		});
	}

	// Toggle the department lists
	const departmentToggle = document.getElementById('department_toggle');
	const departments = document.getElementById('departments');
	if (departmentToggle) {
		departmentToggle.addEventListener('click', (e) => {
			e.preventDefault();
			departments.classList.toggle('hide');
		});
	}

	const tagSelect = document.getElementById('map_object_tag_ids');
	if (tagSelect) {
		new TomSelect(tagSelect);
	}
});
